import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询企微审批模板（包含表头配置）
export function getEnterpriseWechatApprovalTemplates() {
  return request({
    url: 'api/sys-service/enterpriseWechat/approval/templates',
    method: 'get',
    // 返回完整错误，便于前端定位问题
    fullError: true
  })
}

// 查询企微审批实例列表
// data 中建议至少包含：
// - documentConfigId: 选中的模板 ID
// - pageNum / pageSize: 分页参数
// - 以及查询条件（如有）
export function getEnterpriseWechatApprovalInstances(data) {
  return request({
    // 直接使用明确路径，避免 URL 配置异常导致请求落到根路径 '/'
    url: '/api/sys-service/enterpriseWechat/approval/instances',
    method: 'post',
    data,
    // 返回完整错误，便于前端定位问题
    fullError: true
  })
}

// 查询企微审批模板详情（包含控件配置）
export function getEnterpriseWechatApprovalTemplateDetail(params) {
  return request({
    url: '/api/sys-service/enterpriseWechat/approval/templateDetail',
    method: 'get',
    params,
    fullError: true
  })
}
